export default __webpack_public_path__ + "static/media/mc.21f385d1.svg";